import React from "react";
import globals from "../globals";
import Heading from "../elements/Heading";
import CustomLink from "../elements/CustomLink";
import HelmetDefault from "../layout/HelmetDefault";

class OptusCoverage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            seoTitle: '',
            seoDescription: '',
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/coverage')
            .then(result => result.json())
            .then((result) => {
                this.setState({
                    ...result.optus,
                    dataReceived: true
                });
                globals.animatePageIn(this.container);
            });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}} className="coverage-container">
                <HelmetDefault {...this.state} />
                <div className="row my-5 py-lg-5">
                    <div className="col-12 centered">
                        <CustomLink to="/internet/wireless-backup" className="back-link">
                            <img src="/images/arrow-left.svg" alt="back" className="mr-2" />
                            Back
                        </CustomLink>
                        <Heading title={this.state.title} subTitle={this.state.subTitle} />
                        <div className="map-container">
                            <iframe src="/optus/frame.html" frameBorder="none" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default OptusCoverage;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/OptusCoverage.js